module.exports = __webpack_public_path__ + "media/images/FanShopLoopAd_728x90-8c554855421fa8fb144102d984c51f89.png";